import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Col, Tag, Typography } from "antd";
import { painEntryFormConstants } from "../../helpers/painEntryFormConstants";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handleSymptomChange } from "../../redux-toolkit/slices/painEntryFormSlice";

const symptomTrackingOptions: string[] =
  painEntryFormConstants.symptomTrackingOptions;

const TeSymptomTracking = () => {
  const checkedSymptoms = useSelector(
    (state: RootState) => state.painEntryForm.symptoms
  );
  const dispatch = useDispatch();

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Symptom Tracking *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Select any symptoms you're experiencing along with your pain.
      </p>
      <Row gutter={[10, 20]}>
        {symptomTrackingOptions.map((symptom) => (
          <Col
            key={symptom}
            xl={6}
            xxl={6}
            lg={6}
            md={8}
            sm={12}
            xs={12}
            style={{ display: "flex" }}
          >
            <Tag.CheckableTag
              checked={checkedSymptoms.includes(symptom)}
              onChange={() => dispatch(handleSymptomChange(symptom))}
              className="checkable-tag-pain-entry"
            >
              {symptom}
            </Tag.CheckableTag>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TeSymptomTracking;
